/**
 * QueryClient do TanStack Query (app.md §5.3).
 * Defaults conservadores: sem refetch agressivo; retry só em erro transitório.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const code = (error as { code?: string }).code;
        // Não re-tentar erros de autorização/negócio; só rede/http.
        if (code === 'user_not_found' || code === 'expired' || code === 'blocked') return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: 0,
    },
  },
});

/** Chaves de query centralizadas (evita strings mágicas espalhadas). */
export const queryKeys = {
  me: () => ['me'] as const,
  lists: (module: string) => ['lists', module] as const,
  leads: (id: string, limit: number) => ['leads', id, limit] as const,
  places: (id: string, limit: number) => ['places', id, limit] as const,
  placesCards: (filters: unknown, page: number) => ['placesCards', filters, page] as const,
  suggestions: (lang: string) => ['suggestions', lang] as const,
  keywords: (module: string) => ['keywords', module] as const,
};
